import React from "react";
// import InfoIcon from "../../assets/icons/common/infoIcon.svg";
const index = ({value}) => {
  return (
    <div className="w-[100%] flex items-center my-[24px] rounded-tl-[12px] rounded-tr-[12px]  bg-[white] p-[12px] border-b-[2px] border-[#3B82F6]">
      <span className="rounded-[8px] p-[6px] bg-[#EFF6FF]">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M12 16V12M12 8H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
            stroke="#3B82F6"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </span>
      <span>
        <p className="text-[14px] md:text-[18px] pl-[12px]">
         {value}
        </p>
      </span>
    </div>
  );
};

export default index;
